import {Component, OnInit} from '@angular/core';
import {BlockStatementAbstractComponent} from '@core-app/blocks/block-statement-abstract.component';

import type {PaidTimeOffCard} from '@core-app/types/paid-time-off-card.interface';

@Component({
    selector: 'core-block-paid-time-off',
    templateUrl: './block-paid-time-off.component.html',
    standalone: false,
})
export class BlockPaidTimeOffComponent extends BlockStatementAbstractComponent implements OnInit {
    ptoCards: PaidTimeOffCard[] = [];

    override ngOnInit(): void {
        super.ngOnInit();
        this.initializePaidTimeOffData();
    }

    initializePaidTimeOffData(): void {
        // -1 indicates unlimited vacation days
        if (this.authUser.data['VACATION_DAYS'] === '-1') {
            this.ptoCards.push({
                title: 'Vacation Days',
                days: 'Unlimited',
            });
        }

        for (const pto of [
            'VACATION_DAYS',
            'HOLIDAYS',
            'SICK_TIME',
            'CHARITABLE_VOLUNTEERING_DAYS',
        ]) {
            if (parseFloat(this.authUser.data[pto]) > 0) {
                switch (pto) {
                    case 'VACATION_DAYS':
                        this.ptoCards.push({
                            title: 'Vacation Days',
                            days: this.authUser.data[pto],
                        });
                        break;
                    case 'HOLIDAYS':
                        this.ptoCards.push({
                            title: 'Holidays',
                            days: this.authUser.data[pto],
                        });
                        break;
                    case 'SICK_TIME':
                        this.ptoCards.push({
                            title: 'Sick Days',
                            days: this.authUser.data[pto],
                        });
                        break;
                    case 'CHARITABLE_VOLUNTEERING_DAYS':
                        this.ptoCards.push({
                            title: 'Charitable Volunteering',
                            days: this.authUser.data[pto],
                        });
                        break;
                }
            }
        }
    }
}
